import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const makeDefaultCard = async ({ userId, cardId }: { userId: string; cardId: string }) => {
  const response = await mutationExecute({
    variables: {
      userId,
      cardId,
    },
    mutation: graphql(`
      mutation MakeDefaultCard($userId: String!, $cardId: String!) {
        makeDefault(userId: $userId, cardId: $cardId)
      }
    `),
  });

  return !!response.data?.makeDefault;
};
